import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import SearchWordListContainer from '../../containers/searchWord/SearchWordListContainer';
import { SEARCH_WORD_PAGE_NAME } from '../../constants/service/app/searchWordConstants';

const SearchWordList = () => {
  return (
    <PageTemplate pageName={SEARCH_WORD_PAGE_NAME.SEARCH_WORD_LIST}>
      <SearchWordListContainer />
    </PageTemplate>
  );
};

export default SearchWordList;
